import Event from '../../core/Event';

export default class ValueFromSliderChanged extends Event {
    public static type = 'ValueFromSliderChanged';

    constructor(public readonly sliderValue?: number) {
        super(ValueFromSliderChanged.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/ValueFromSliderChanged.ts